import { mapProperties } from '@/utils/property-mapping'

const buildProductProperties = {
  methods: {
    /**
     * Safely get a value from parameter object, returning a translated placeholder if missing
     * @param {Object} paramObj - Parameter object to access
     * @param {String} propName - Property name to access
     * @param {String} transKey - Translation key for empty value
     * @returns {String} Property value or placeholder
     */
    _safeGetParam(paramObj, propName, transKey = 'NULL') {
      if (!paramObj || typeof paramObj !== 'object') {
        return transKey;
      }
      const value = paramObj[propName];
      if (value && propName.includes('Properties') && value.startsWith('parameterValues.')) {
        return this.$t("parameterValues." + value);
      }
      return value || transKey;
    },
    
    async buildProductProperties ({ cable, plugA, plugB, configuratorType }) {
      try {
        // Safely extract cable parameters, handling cases where cable doesn't exist in API response (e.g., MTP12 in RZ Standard)
        const cableData = cable && (await this.axios.get(`https://directus-api.sachsenkabel.de/_/items/${configuratorType}_cables_${this.$store.state.getsDataCenterProducts ? 'datacenter_' : '' }parameters?single=1`)).data.data.data.filter(i => i.artikel_id === cable.id)[0];
        const cableParametersDirectus = cableData ? [cableData] : []

        // debugger //eslint-disable-line
        let cableParameters = mapProperties('productParameters', cableParametersDirectus)
        let plugProperties = await this.axios.get(`https://directus-api.sachsenkabel.de/_/items/${configuratorType}_plugs_${this.$store.state.getsDataCenterProducts ? 'datacenter_' : '' }parameters?single=1`)
        
        
        // Safely extract plug parameters, handling cases where plug tidak exist in API response
        const plugAData = plugA && plugProperties.data.data.data.filter(i => i.artikel_id === plugA.id)[0];
        const plugBData = plugB && plugProperties.data.data.data.filter(i => i.artikel_id === plugB.id)[0];
        
        const plugAParametersDirectus = plugAData ? [plugAData] : []
        const plugBParametersDirectus = plugBData ? [plugBData] : []
        // debugger
        let plugAParameters = mapProperties('productParameters', plugAParametersDirectus)
        let plugBParameters = mapProperties('productParameters', plugBParametersDirectus)

        // eslint-disable-next-line
        console.log(cableParameters, plugAParameters, plugBParameters)

        let cableProperties = [
          {
            key: this.$t('cable-type'),
            value: this.selectedValue('cables', 'cableType')
          },
          {
            key: this.$t('cableManufacturer'),
            value: this.selectedValue('cables', 'manufacturer')
          },
          {
            key: this.$t('fiber-count'),
            value: this.selectedValue('cables', 'fiberCount')
          },
          {
            key: this.$t('cableCoreDiameter'),
            value: this.selectedValue('cables', 'fiberClass')
          },
          {
            key: this.$t('outerDiameter'),
            value: cableParameters[0].cloakDiameter ? this.$t("parameterValues." + cableParameters[0].cloakDiameter) : 'NULL'
          },
          {
            key: this.$t('outerColor'),
            value: this.$t("colorNames." + this.selectedValue('cables', 'cableColor'))
          },
          {
            key: this.$t('outerMaterial'),
            value: cableParameters[0].cloakMaterial ? this.$t("parameterValues." + cableParameters[0].cloakMaterial) : 'NULL'
          },
          {
            key: this.$t('minimalBendRadius'),
            value: cableParameters[0].minimalBendRadius ? this.$t("parameterValues." + cableParameters[0].minimalBendRadius) : 'NULL'
          },
          {
            key: this.$t('crushStrength'),
            value: cableParameters[0].crushStrength ? this.$t("parameterValues." + cableParameters[0].crushStrength) : 'NULL'
          },
          {
            key: this.$t('traction'),
            value: cableParameters[0].traction ? this.$t("parameterValues." + cableParameters[0].traction) : 'NULL'
          },
          {
            key: this.$t('cableWeight'),
            value: cableParameters[0].weight ? this.$t("parameterValues." + cableParameters[0].weight) : 'NULL'
          },
          {
            key: this.$t('operationTemperature'),
            value: cableParameters[0].operationTemperature ? this.$t("parameterValues." + cableParameters[0].operationTemperature) : 'NULL'
          },
          {
            key: this.$t('cable-cpr'),
            value: this.selectedValue('cables', 'cpr')
          }
        ]

        if (this.shouldShowPolaritySelector && this.selectedValue('polarity', 'value')) {
          cableProperties.push({
            key: this.$t('cable-polarity'),
            value: this.selectedValue('polarity', 'value')
          })
        }
        
        let plugAProperties = [
          {
            key: this.$t('plugDescription'),
            value: `${ this.selectedValue('plugsA', 'plugType') }${ this.selectedValue('plugsA', 'polish') } ${ this.selectedValue('cables', 'fiberClass').indexOf('OS') === 0 ? 'Singlemode' : 'Multimode' }${ this.selectedValue('plugsA', 'plex').toLowerCase() !== this.selectedValue('plugsA', 'plugType').toLowerCase() ? ' ' + this.selectedValue('plugsA', 'plex').toUpperCase() : '' }`
          },
          {
            key: this.$t('designSpecification'),
            value: this._safeGetParam(plugAParameters[0], 'designSpecification')
          },
          {
            key: this.$t('manufacturer'),
            value: this.selectedValue('plugsA', 'manufacturer')
          },
          {
            key: this.$t('ferrule'),
            value: plugAParameters[0] && plugAParameters[0].ferruleProperties ? this.$t("parameterValues." + plugAParameters[0].ferruleProperties) : 'NULL'
          },
          {
            key: this.$t('operationTemperature'),
            value: this._safeGetParam(plugAParameters[0], 'operationTemperature')
          },
          {
            key: this.$t('ferruleMaterial'),
            // wenn Keramik dann Keramik / Farbe ansosnten Metall
            value: `${ this.selectedValue('plugsA', 'plugColor') !== 'metall' ? this.$t("Kunststoff") : '' }${ this.selectedValue('plugsA', 'plugColor') && this.selectedValue('plugsA', 'plugColor') === 'metall' ? this.$t("colorNames." + this.selectedValue('plugsA', 'plugColor')) : ' / ' + this.$t("colorNames." + this.selectedValue('plugsA', 'plugColor'))}`
          },
          {
            key: this.$t('plugCycles'),
            value: this._safeGetParam(plugAParameters[0], 'plugCycles')
          },
          {
            key: this.$t('insertionLoss'),
            value: this._safeGetParam(plugAParameters[0], 'insertionLoss')
          },
          {
            key: this.$t('returnLoss'),
            value: this._safeGetParam(plugAParameters[0], 'returnLoss')
          },
          {
            key: this.$t('bend-protection'),
            value: this.selectedBendProtectionA.colorTop !== this.selectedBendProtectionA.colorBottom 
              ? `${ this.$t("colorNames." + this.selectedBendProtectionA.colorTop) }/${ this.$t("colorNames." + this.selectedBendProtectionA.colorBottom) }${ this.$t(this.selectedBendProtectionA.flexibility) }`
              : `${ this.$t("colorNames." + this.selectedBendProtectionA.colorTop) } ${ this.$t(this.selectedBendProtectionA.flexibility) }`
          }
        ]

        if (configuratorType === 'trunk') {
          plugAProperties = plugAProperties.concat([
            {
              key: this.$t('spreader'),
              value: this.$store.state.filters.spreadersA.id 
                ? 
                  this.$i18n.locale === 'de'
                    ? `${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersA', 'id'))[0].description} ${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersA', 'id'))[0].material}`
                    : `${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersA', 'id'))[0].times}-times Dividing element ${this.$t(this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersA', 'id'))[0].material)}` 
                : this.$t('shrinking-tube')
            },
            {
              key: this.$t('whip'),
              value: this.$i18n.locale !== 'en' 
                ? this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsA', 'id'))[0].length
                : this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsA', 'id'))[0].length.replace(',', '.')
            },
            {
              key: this.$t('fixation'),
              value: this.selectedValue('fixationsA', 'id')
                ? `${ this.$store.state.fixations.filter(item => item.id === this.selectedValue('fixationsA', 'id') )[0].size } ${ this.$t('inkl. Gegenmutter')}`
                : ''
            },
            {
              key: this.$t('protection'),
              value: this.selectedValue('protectionsA', 'id')
              ? this.$t(this.$store.state.protections.filter(item => item.id === this.selectedValue('protectionsA', 'id') )[0].description)
              : ''
            }
          ])
        }

        if (configuratorType === 'breakout') {
          plugAProperties = plugAProperties.concat([
            {
              key: this.$t('whip'),
              value: this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsA', 'id'))[0].length
            },
            {
              key: this.$t('fixation'),
              value: this.selectedValue('fixationsA', 'id')
                ? `${ this.$store.state.fixations.filter(item => item.id === this.selectedValue('fixationsA', 'id') )[0].size } ${ this.$t('inkl. Gegenmutter')}`
                : ''
            },
            {
              key: this.$t('protection'),
              value: this.selectedValue('protectionsA', 'id')
              ? this.$t(this.$store.state.protections.filter(item => item.id === this.selectedValue('protectionsA', 'id') )[0].description)
              : ''
            }
          ])
        }

        let plugBProperties = []
        if (this.isPigtail) {
          Object.keys(plugAProperties).forEach(key => {
            Object.assign(plugBProperties, {
              key,
              value: ''
            })
          })
        } else {
          plugBProperties = [
            {
              key: this.$t('plugDescription'),
              value: `${ this.selectedValue('plugsB', 'plugType') }${ this.selectedValue('plugsB', 'polish') } ${ this.selectedValue('cables', 'fiberClass').indexOf('OS') === 0 ? 'Singlemode' : 'Multimode' }${ this.selectedValue('plugsB', 'plex').toLowerCase() !== this.selectedValue('plugsB', 'plugType').toLowerCase() ? ' ' + this.selectedValue('plugsB', 'plex').toUpperCase() : '' }`
            },
            {
              key: this.$t('designSpecification'),
              value: this._safeGetParam(plugBParameters[0], 'designSpecification')
            },
            {
              key: this.$t('manufacturer'),
              value: this.selectedValue('plugsB', 'manufacturer')
            },
            {
              key: this.$t('ferrule'),
              value: plugBParameters[0] && plugBParameters[0].ferruleProperties ? this.$t("parameterValues." + plugBParameters[0].ferruleProperties): 'NULL'
            },
            {
              key: this.$t('operationTemperature'),
              value: this._safeGetParam(plugBParameters[0], 'operationTemperature')
            },
            {
              key: this.$t('ferruleMaterial'),
              // wenn Keramik dann Keramik / Farb ansosnten Metall
              value: `${ this.selectedValue('plugsB', 'plugColor') !== 'metall' ? this.$t("Kunststoff") : '' }${ this.selectedValue('plugsB', 'plugColor') && this.selectedValue('plugsB', 'plugColor') === 'metall' ? this.$t("colorNames." + this.selectedValue('plugsB', 'plugColor')) : ' / ' + this.$t("colorNames." + this.selectedValue('plugsB', 'plugColor'))}`
            },
            {
              key: this.$t('plugCycles'),
              value: this._safeGetParam(plugBParameters[0], 'plugCycles')
            },
            {
              key: this.$t('insertionLoss'),
              value: this._safeGetParam(plugBParameters[0], 'insertionLoss')
            },
            {
              key: this.$t('returnLoss'),
              value: this._safeGetParam(plugBParameters[0], 'returnLoss')
            },
            {
              key: this.$t('bend-protection'),
              value: this.selectedBendProtectionB.colorTop !== this.selectedBendProtectionB.colorBottom 
                ? `${ this.$t("colorNames." + this.selectedBendProtectionB.colorTop) }/${ this.$t("colorNames." + this.selectedBendProtectionB.colorBottom) }${ this.$t(this.selectedBendProtectionB.flexibility) }`
                : `${ this.$t("colorNames." + this.selectedBendProtectionB.colorTop) } ${ this.$t(this.selectedBendProtectionB.flexibility) }`
            }
            
          ]

          if (configuratorType === 'trunk') {
            plugBProperties = plugBProperties.concat([
              {
                key: this.$t('spreader'),
                value: this.$store.state.filters.spreadersB.id 
                ? 
                  this.$i18n.locale === 'de'
                    ? `${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersB', 'id'))[0].description} ${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersB', 'id'))[0].material}`
                    : `${this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersB', 'id'))[0].times}-times Dividing element ${this.$t(this.$store.state.spreaders.filter(item => item.id === this.selectedValue('spreadersB', 'id'))[0].material)}` 
                : this.$t('shrinking-tube')
              },
              {
                key: this.$t('whip'),
                value: this.$i18n.locale !== 'en' 
                ? this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsB', 'id'))[0].length
                : this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsB', 'id'))[0].length.replace(',', '.')
              },
              {
                key: this.$t('fixation'),
                value: this.selectedValue('fixationsB', 'id')
                  ? `${ this.$store.state.fixations.filter(item => item.id === this.selectedValue('fixationsB', 'id') )[0].size } ${ this.$t('inkl. Gegenmutter')}`
                  : ''
              },
              {
                key: this.$t('protection'),
                value: this.selectedValue('protectionsB', 'id')
                ? this.$t(this.$store.state.protections.filter(item => item.id === this.selectedValue('protectionsB', 'id') )[0].description)
                : ''
              }
            ])
          }

          if (configuratorType === 'breakout') {
            plugBProperties = plugBProperties.concat([
              {
                key: this.$t('whip'),
                value: this.$store.state.whips.filter(item => item.id === this.selectedValue('whipsB', 'id'))[0].length
              },
              {
                key: this.$t('fixation'),
                value: this.selectedValue('fixationsB', 'id')
                  ? `${ this.$store.state.fixations.filter(item => item.id === this.selectedValue('fixationsB', 'id') )[0].size } ${ this.$t('inkl. Gegenmutter')}`
                  : ''
              },
              {
                key: this.$t('protection'),
                value: this.selectedValue('protectionsB', 'id')
                ? this.$t(this.$store.state.protections.filter(item => item.id === this.selectedValue('protectionsB', 'id') )[0].description)
                : ''
              }
            ])
          }
          
        }

        // create a unique set of keys
        let unionPlugKeys = [...new Set(
          plugAProperties.map(item => item.key)
            .concat(plugBProperties.map(item => item.key))
        )]

        // combine plugA and PlugB
        let combinedDataset = unionPlugKeys.map((key, index) => {
          return {
            key,
            valueA: plugAProperties[index].value,
            valueB: this.isPigtail
              ? '' 
              : plugBProperties[index].value,
          }
        })

        // filter out rows where there is no content
        combinedDataset = combinedDataset.filter(item => !(item.valueA === '' && item.valueB === '' && item.value !== 'null'))

        // filter parameterValues.xxx and replace simply by the value after .
        // get rid of old CPR fields
        cableProperties.filter(item => item.key.indexOf('CPR') === -1).forEach(item => item.value.replace('parameterValues.', ''))
        combinedDataset.forEach(item => {
          item.valueA.replace('parameterValues.', '')
          item.valueB.replace('parameterValues.', '')
        })

        let configuration = { 
          // create unified key value object array
          cable: cableProperties.filter(item => item.value && item.value !== '' && item.value !== 'null'),
          plugA: combinedDataset.map(item => ({
            key: item.key,
            value: item.valueA
          })),
          plugB: combinedDataset.map(item => ({
            key: item.key,
            value: item.valueB
          }))
        }

        // this.$rollbar.debug(`missing paramters or translations`, {
        //   ...configuration
        // })
        return configuration
      }
      catch(err) {
        // Improved error logging with context for debugging RZ Standard (DataCenter) mode issues
        const brandMode = this.$store.state.getsDataCenterProducts ? 'RZ Standard (DataCenter)' : 'Sachsenkabel Standard';
        const errorContext = {
          error: err.message || err,
          brandMode: brandMode,
          configuratorType: configuratorType,
          plugAExists: !!plugA,
          plugBExists: !!plugB,
          cableExists: !!cable
        };
        this.$rollbar.error(`buildProductProperties failed in ${brandMode} mode`, errorContext);
        
        // Return a valid but minimal configuration to prevent downstream errors
        // This ensures the template has something to work with even if parameters are missing
        const fallbackCableProperties = [
          {
            key: this.$t('cable-type'),
            value: this.selectedValue('cables', 'cableType')
          },
          {
            key: this.$t('cableManufacturer'),
            value: this.selectedValue('cables', 'manufacturer')
          },
          {
            key: this.$t('fiber-count'),
            value: this.selectedValue('cables', 'fiberCount')
          }
        ];

        if (this.shouldShowPolaritySelector && this.selectedValue('polarity', 'value')) {
          fallbackCableProperties.push({
            key: this.$t('cable-polarity'),
            value: this.selectedValue('polarity', 'value')
          });
        }

        return {
          cable: fallbackCableProperties,
          plugA: [
            {
              key: this.$t('plugDescription'),
              value: `${this.selectedValue('plugsA', 'plugType')}${this.selectedValue('plugsA', 'polish')} ${this.selectedValue('cables', 'fiberClass').indexOf('OS') === 0 ? 'Singlemode' : 'Multimode'}${this.selectedValue('plugsA', 'plex').toLowerCase() !== this.selectedValue('plugsA', 'plugType').toLowerCase() ? ' ' + this.selectedValue('plugsA', 'plex').toUpperCase() : ''}`
            },
            {
              key: this.$t('manufacturer'),
              value: this.selectedValue('plugsA', 'manufacturer')
            }
          ],
          plugB: [
            {
              key: this.$t('plugDescription'),
              value: this.isPigtail ? '' : `${this.selectedValue('plugsB', 'plugType')}${this.selectedValue('plugsB', 'polish')} ${this.selectedValue('cables', 'fiberClass').indexOf('OS') === 0 ? 'Singlemode' : 'Multimode'}${this.selectedValue('plugsB', 'plex').toLowerCase() !== this.selectedValue('plugsB', 'plugType').toLowerCase() ? ' ' + this.selectedValue('plugsB', 'plex').toUpperCase() : ''}`
            },
            {
              key: this.$t('manufacturer'),
              value: this.isPigtail ? '' : this.selectedValue('plugsB', 'manufacturer')
            }
          ]
        };
      }
    }
  }
}

export default buildProductProperties
